module.exports = __webpack_public_path__ + "static/media/diploma.4605d0e7.svg";